let version = 'weekly';

export default {
  get: () => version,
  set: newVersion => { version = newVersion; },
};
